import { Textarea } from '@/shared/components';
import { DEFAULT_CRYPTO_ADDRESS_PATTERN } from '@/shared/config';
import { createRegexTextareaHandlers } from '@/shared/lib';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from '@/shared/utils';

type Props = {
  label: string;
  onChange: (value: string) => void;
  className?: string;
  onValueChange?: () => void;
} & Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'>;

export const CryptoAddressField = ({
  label,
  className,
  onChange,
  onValueChange,
  ...props
}: Props) => {
  const addressHandlers = createRegexTextareaHandlers(
    new RegExp(`^[${DEFAULT_CRYPTO_ADDRESS_PATTERN}]+$`),
    onChange
  );

  return (
    <Textarea
      {...props}
      label={label}
      className={cn('p3', className)}
      autoGrow={true}
      onBeforeInput={addressHandlers.beforeInput}
      onPaste={addressHandlers.paste}
      onChange={e => {
        addressHandlers.change(e);
        onValueChange?.();
      }}
      onKeyDown={e => {
        if (e.key === ' ') {
          e.preventDefault();
        }
      }}
    />
  );
};
